import React, { useContext } from "react";
import styles from "./Footer.module.scss";
import { Context } from "../Store";
import { trackEvent } from "../utils/helpers";

const socialUrlsByCountry = {
  uk: {
    facebook: "https://www.facebook.com/flightclubdarts",
    instagram: "https://www.instagram.com/flightclubdarts",
    linkedin: "https://www.linkedin.com/company/flightclubdarts",
    youtube: "https://www.youtube.com/@flightclub5245",
    tiktok: "https://www.tiktok.com/@flightclubdarts",
  },
  us: {
    facebook: "https://www.facebook.com/FlightClubDartsUSA",
    instagram: "https://www.instagram.com/flightclubdartsusa/",
    linkedin: "https://www.linkedin.com/company/flight-club-darts-usa",
    youtube: "https://www.youtube.com/@flightclubdartsusa",
    tiktok: "https://www.tiktok.com/@flightclubusa",
  },
  aus: {
    facebook: "https://www.facebook.com/flightclubaustralia",
    instagram: "https://www.instagram.com/flightclubaus/",
    linkedin: "https://www.linkedin.com/company/flight-club-australia/",
    youtube: "https://www.youtube.com/@flightclub5245",
    // tiktok intentionally excluded
  },
  ie: {
    facebook: "https://www.facebook.com/people/Flight-Club-Dublin/61567261340606/",
    instagram: "https://www.instagram.com/flightclubdublin",
    linkedin: "https://www.linkedin.com/company/flight-club-ireland",
    youtube: "https://www.youtube.com/@flightclub5245",
    tiktok: "https://www.tiktok.com/@flightclubdublin",
  },
};

const Footer = (props) => {
  const [state] = useContext(Context);
  let country = state.country;
  const preURL =
    country === "us"
      ? "https://www.flightclubdartsusa.com"
      : country === "aus"
        ? "https://flightclubdarts.com.au"
        : country === "ie"
          ? "https://flightclubdarts.com/ie"
          : "https://flightclubdarts.com";

  const socialUrls = socialUrlsByCountry[country] || {};
  const visiblePlatforms = Object.keys(socialUrls);

  return (
    <footer className={styles.footer}>
      {/* Top Section */}
      <section className={`${styles.footerTop} ${country === "ie" ? styles.desktopOnly : ""}`}>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            {(country === "uk" || country === "ie") && (
              <ul className={styles.menu}>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/contact`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Contact Us")}
                  >
                    CONTACT US
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/faqs`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "FAQS")}
                  >
                    FAQs
                  </a>
                </li>
              </ul>
            )}
            {country === "aus" && (
              <ul className={styles.menu}>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/our-story`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Our Story")}
                  >
                    OUR STORY
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/contact`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Contact")}
                  >
                    CONTACT US
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/gift-voucher`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Gift Voucher")}
                  >
                    GIFT VOUCHERS
                  </a>
                </li>
              </ul>
            )}
            {country === "us" && (
              <ul className={styles.menu}>
                <li className={styles.menuItem}>
                  Social Darts<sup>®</sup> (2-12 people)
                </li>
                <li className={styles.menuItem}>Events (13+ people)</li>
              </ul>
            )}
          </div>

          <div className={styles.logoWrapper}>
            <img src="./img/fc_footer-logo.svg" alt="Flight Club Darts Logo" />
          </div>

          <div className={styles.wrapper}>
            {country === "uk" && (
              <ul className={styles.menu}>
                <li className={styles.menuItem}>
                  <a
                    href="https://red-engine.com/yellow-ball"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Purpose")}
                  >
                    PURPOSE
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/international-partnerships`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Global Partners")}
                  >
                    GLOBAL PARTNERS
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href="https://careers.flightclubdarts.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Careers")}
                  >
                    CAREERS
                  </a>
                </li>
              </ul>
            )}
            {country === "aus" && (
              <ul className={styles.menu}>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/faqs`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "FAQs")}
                  >
                    FAQs
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href={`${preURL}/international-partnerships`}
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "International Partnerships")}
                  >
                    INTERNATIONAL PARTNERSHIPS
                  </a>
                </li>
                <li className={styles.menuItem}>
                  <a
                    href="https://flightclubdarts.com.au/careers"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.menuLink}
                    onClick={() => trackEvent("External Link", "Careers")}
                  >
                    CAREERS
                  </a>
                </li>
              </ul>
            )}
          </div>
        </div>
      </section>

      {/* Social */}
      <section className={`${styles.footerMiddle}`}>
        <div className={styles.container}>
          <div className={styles.socialWrapper}>
            <ul className={styles.socialMenu}>
              {visiblePlatforms.map((platform) => (
                <li key={platform}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={socialUrls[platform]}
                    onClick={() => trackEvent("External Link", `${platform}`)}
                  >
                    <img
                      alt={`Flight Club Darts ${platform.charAt(0).toUpperCase() + platform.slice(1)}`}
                      className={styles.socialIcon}
                      src={`./img/fc_common_icon_${platform}.png`}
                    />
                    <span></span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.globalRegionWrapper}>
            <div className={`${styles.contact}`}>
              {country === "ie" ? (
                <a
                  className={`${styles.menuLink} ${styles.blankLink}`}
                  href="mailto:welcome@flightclubdarts.ie"
                  onClick={() => trackEvent("External Link", "Email")}
                >
                  welcome@flightclubdarts.ie
                </a>
              ) : country !== "us" ? (
                <a
                  className={`${styles.menuLink} ${styles.blankLink}`}
                  href="mailto:bookings@flightclubdarts.com"
                  onClick={() => trackEvent("External Link", "Email")}
                >
                  bookings@flightclubdarts.com
                </a>
              ) : null}
            </div>
            <div className={styles.regionMenu}>
              <span className={styles.regionPreText}>WE'RE GLOBAL:</span>
              <a
                href="https://flightclubdarts.com"
                className={styles.regionLink + " active"}
                onClick={() => trackEvent("External Link", "UK")}
              >
                UK
              </a>{" "}
              |
              <a
                href="https://flightclubdartsusa.com"
                className={styles.regionLink}
                onClick={() => trackEvent("External Link", "USA")}
              >
                USA
              </a>{" "}
              |
              <a
                href="https://flightclubdarts.com.au/"
                className={styles.regionLink}
                onClick={() => trackEvent("External Link", "AUS")}
              >
                AUS
              </a>{" "}
              |
              <a
                href="https://flightclubdarts.com/ie/"
                className={styles.regionLink}
                onClick={() => trackEvent("External Link", "IRL")}
              >
                IRL
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Bottom Section */}
      <section className={styles.footerBottom}>
        <div className={styles.container}>
          {/* Legal & Info */}
          <div className={styles.container}>
            FLIGHT CLUB®, the FLIGHT CLUB® logo and SOCIAL DARTS® are registered trademarks of
            Flight&nbsp;Path&nbsp;IP&nbsp;Limited. From the team behind{" "}
            <a
              href="https://electricshuffle.com"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("External Link", "Electric Shuffle")}
            >
              Electric&nbsp;Shuffle®
            </a>
          </div>
          {country !== "us" ? (
            <div className={styles.container}>
              <a href={`${preURL}/booking-terms-and-conditions`}>Terms &amp; Conditions</a> |
              <a
                href={`${preURL}/privacy-policy`}
                onClick={() => trackEvent("External Link", "Privacy Policy")}
              >
                Privacy Policy
              </a>{" "}
              |
              <a
                href={`${preURL}/cookie-policy`}
                onClick={() => trackEvent("External Link", "Cookie Policy")}
              >
                Cookie Policy
              </a>{" "}
              |
              <a
                href="/pdfs/flightclub-genderpayreport2024.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("External Link", "Gender Pay Report")}
              >
                Gender Pay Report
              </a>{" "}
              |
              <a
                href="/pdfs/flight-club-modern-slavery-policy-june-2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("External Link", "Modern Slavery")}
              >
                Modern Slavery
              </a>
            </div>
          ) : (
            <div className={styles.container}>
              <br />
              Flight Club Darts USA is owned by State of Play Hospitality Limited, an independent business
              operating under the FLIGHT CLUB US INC. name as a franchisee of Flight Path IP Limited.
            </div>
          )}
        </div>
      </section>
    </footer>
  );
};

export default Footer;
